import { render, staticRenderFns } from "./JobsToDo.vue?vue&type=template&id=2bb78c73&"
import script from "./JobsToDo.vue?vue&type=script&lang=js&"
export * from "./JobsToDo.vue?vue&type=script&lang=js&"
import style0 from "./JobsToDo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports